var $f4095fb5a72adbe6$exports = {};
$f4095fb5a72adbe6$exports = {
    "close": `Cerrar`,
    "notifications": `Notificaciones`
};


export {$f4095fb5a72adbe6$exports as default};
//# sourceMappingURL=es-ES.mjs.map
